import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SecurityPage from "../pages/security/page";
import ShoppingGuide from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/security",
    element: <SecurityPage />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;